import { useMutation } from "@tanstack/react-query";
import { Dropdown, Menu, Modal, message } from "antd";
import { useState } from "react";
import { MdMoreVert } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { UpdateBulkStatus, deleteBulkSalonAdmin } from "../../../network/admin";
import queryClient from "../../../services/react-query/queryClient";
import ConfirmModal from "./ConfirmModal";

type Props = { LocationId: number }; // If not used, consider removing it or adding relevant props.

const ActionMenuHeader = ({ LocationId }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState({
    title: "",
    para: "",
    status: "",
    color: "",
  });
  const navigate = useNavigate();

  const showModal = (
    title: string,
    para: string,
    status: string,
    color: string
  ) => {
    setConfirmMessage({ title, para, status, color });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const actionItems = [
    {
      color: "#C43535",
      text: "Delete Salon",
      title: "Confirm Deletion",
      description: "Are you sure you want to delete this salon?",
      status: "delete",
    },
    {
      color: "#479821",
      text: "Accept Salon",
      title: "Confirm Acceptance",
      description: "Accept this salon?",
      status: "active",
    },
    {
      color: "#75757E",
      text: "Reject Salon",
      title: "Confirm Rejection",
      description: "Reject this salon?",
      status: "reject",
    },
    {
      color: "#75757E",
      text: "Block Salon",
      title: "Confirm Block",
      description: "Block this salon?",
      status: "blocked",
    },
  ];

  const menuItems = (
    <Menu className="!py-4 !px-5 min-w-[220px]">
      {actionItems.map((item, index) => (
        <>
          <Menu.Item
            key={index}
            className="!p-0 "
            onClick={() =>
              showModal(item.title, item.description, item.status, item?.color)
            }
          >
            <span
              style={{ color: item?.color }}
              className={`text-sm font-normal`}
            >
              {item.text}
            </span>
          </Menu.Item>
          {index < actionItems.length - 1 && <Menu.Divider className="!my-3" />}
        </>
      ))}
    </Menu>
  );
  const {
    mutate: updateSalonStatus,
    isLoading: isSubmitting,
    error: addSalonError,
  } = useMutation(UpdateBulkStatus, {
    onSuccess: (res: any) => {
      if (res?.code === "ERR_BAD_REQUEST") {
        message.error(res?.response?.data?.message);
      } else {
        message.success("Status Salons Updated Successfully");
        queryClient.invalidateQueries(["location"]);
        closeModal();
      }
    },
  });
  const { mutate: deleteSalonStatus, isLoading: isDeleteing } = useMutation(
    deleteBulkSalonAdmin,
    {
      onSuccess: (res: any) => {
        if (res?.code === "ERR_BAD_REQUEST" || "ERR_BAD_RESPONSE") {
          message.error(res?.response?.data?.message);
        } else {
          console.log(res);
          message.success("Salon Deleted Successfully");
          queryClient.invalidateQueries(["location"]);
          navigate("/admin/salon-management");
          closeModal();
        }
      },
    }
  );
  return (
    <>
      <Modal
        width="30%"
        open={isModalOpen}
        centered
        onCancel={closeModal}
        className="max-md:min-w-[95%] max-lg:min-w-[80%]"
        footer={null}
        destroyOnClose
      >
        <ConfirmModal
          LocationId={LocationId}
          title={confirmMessage.title}
          para={confirmMessage.para}
          status={confirmMessage.status}
          closeModal={closeModal}
          color={confirmMessage.color}
          requestDelete={deleteSalonStatus}
          requestStatus={updateSalonStatus}
        />
      </Modal>
      <Dropdown
        trigger={["click"]}
        overlay={menuItems}
        placement="bottomRight"
        className="flex items-center justify-end cursor-pointer h-fit w-fit"
      >
        <div className="flex w-fit text-sm text-color-primary items-center justify-end bg-white px-2 py-[6px] rounded-lg gap-1 h-fit">
          <MdMoreVert />
          <span className="h-fit">Actions</span>
        </div>
      </Dropdown>
    </>
  );
};

export default ActionMenuHeader;
